var _path, _path2, _path3;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMessagecomment = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 45.62C22.62 45.62 21.32 44.92 20.4 43.7L17.4 39.7C17.34 39.62 17.1 39.52 17 39.5H16C7.66 39.5 2.5 37.24 2.5 26V16C2.5 7.16 7.16 2.5 16 2.5H32C40.84 2.5 45.5 7.16 45.5 16V26C45.5 34.84 40.84 39.5 32 39.5H31C30.84 39.5 30.7 39.58 30.6 39.7L27.6 43.7C26.68 44.92 25.38 45.62 24 45.62ZM16 5.5C8.84 5.5 5.5 8.84 5.5 16V26C5.5 35.04 8.6 36.5 16 36.5H17C18.02 36.5 19.18 37.08 19.8 37.9L22.8 41.9C23.5 42.82 24.5 42.82 25.2 41.9L28.2 37.9C28.86 37.02 29.9 36.5 31 36.5H32C39.16 36.5 42.5 33.16 42.5 26V16C42.5 8.84 39.16 5.5 32 5.5H16Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 17.5H14C13.18 17.5 12.5 16.82 12.5 16C12.5 15.18 13.18 14.5 14 14.5H34C34.82 14.5 35.5 15.18 35.5 16C35.5 16.82 34.82 17.5 34 17.5Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27.5H14C13.18 27.5 12.5 26.82 12.5 26C12.5 25.18 13.18 24.5 14 24.5H26C26.82 24.5 27.5 25.18 27.5 26C27.5 26.82 26.82 27.5 26 27.5Z",
    fill: "#455CC7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessagecomment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/messagecomment.1302a8cd.svg";
export { ForwardRef as ReactComponent };